module.exports = __webpack_public_path__ + "static/media/QL-Contact-Two-Tone.16122798.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/QL-Contact-Two-Tone.svg
// module id = 248
// module chunks = 0